import React from 'react';
import { motion } from 'framer-motion';
import { ClipboardList, Users, Scale, Phone, FileText, Home, Heart, BookOpen, ArrowRight } from 'lucide-react';
const COVER_URL = 'https://cdn.magicpatterns.com/uploads/mxhHXRmrKE17QFZqnjyvyS/pasted-image.png';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/bu7HghncWH54Ng2YUSHKCe/imagen_de_imprimibles1.png';
const items = [{
  icon: ClipboardList,
  title: 'Plan Familiar de Emergencia',
  desc: 'Pasos claros para actuar si ICE llega'
}, {
  icon: Users,
  title: 'Hoja de Custodia de Menores',
  desc: 'Protege a tus hijos legalmente'
}, {
  icon: Scale,
  title: 'Tarjeta de Derechos Legales',
  desc: 'Tus derechos en una sola hoja imprimible'
}, {
  icon: Phone,
  title: 'Lista de Contactos Clave',
  desc: 'Abogados, organizaciones y números de emergencia'
}, {
  icon: FileText,
  title: 'Checklist de Documentos',
  desc: 'Todo lo que debes tener organizado'
}, {
  icon: Home,
  title: 'Protocolo Si Tocan Tu Puerta',
  desc: 'Qué decir y qué NO decir'
}, {
  icon: Heart,
  title: 'Guía de Salud Mental',
  desc: 'Recursos para el bienestar emocional'
}, {
  icon: BookOpen,
  title: 'Glosario Legal Simplificado',
  desc: 'Términos legales en lenguaje sencillo'
}];
export function ActionKit() {
  return <section className="py-24 bg-[#0c1222] text-white border-t border-white/10 overflow-hidden" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4 uppercase tracking-wide" data-id="element-4">
            El Kit de Acción Inmediata
          </h2>
          <div className="w-24 h-1 bg-[#c0392b] mx-auto" data-id="element-5" />
        </motion.div>

        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-6">
          {/* Left Column: Visual Bundle */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="flex-1 flex flex-col items-center" data-id="element-7">
            <div className="relative w-full max-w-[480px] sm:max-w-[540px]" data-id="element-8">
              {/* Subtle glow behind image */}
              <div className="absolute -inset-4 bg-[#c0392b]/10 blur-3xl rounded-2xl" data-id="element-9" />
              <img src={MOCKUP_URL} alt="Tablet con Invisibles pero Invencibles e imprimibles prácticos sobre una mesa" className="relative w-full h-auto block rounded-xl shadow-2xl" loading="eager" data-id="element-10" />
            </div>
            <p className="mt-6 text-gray-400 font-serif italic text-lg text-center" data-id="element-11">
              Guía Principal + 8 Imprimibles Prácticos
            </p>
          </motion.div>

          {/* Right Column: List */}
          <div className="flex-1 w-full" data-id="element-12">
            <motion.h3 initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} className="text-2xl font-serif font-bold text-white mb-8 text-center lg:text-left" data-id="element-13">
              Lo que recibes al instante:
            </motion.h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-14">
              {items.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 15
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.05,
              duration: 0.5
            }} className="flex items-start space-x-4 p-4 rounded-lg bg-white/5 border border-white/5 hover:bg-white/10 transition-colors" data-id="element-15">
                  <div className="flex-shrink-0 p-2 rounded-full bg-[#c0392b]/20 text-[#c0392b]" data-id="element-16">
                    <item.icon className="w-5 h-5" data-id="element-17" />
                  </div>
                  <div data-id="element-18">
                    <h4 className="font-bold text-white text-sm sm:text-base mb-1" data-id="element-19">
                      {item.title}
                    </h4>
                    <p className="text-xs sm:text-sm text-gray-400 leading-snug" data-id="element-20">
                      {item.desc}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </div>

        {/* Bottom Callout */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} className="mt-16 max-w-3xl mx-auto text-center" data-id="element-21">
          <div className="border border-[#c0392b]/30 bg-[#c0392b]/5 p-8 rounded-xl backdrop-blur-sm" data-id="element-22">
            <p className="text-xl md:text-2xl font-serif text-white mb-6" data-id="element-23">
              Todo esto por solo{' '}
              <span className="text-[#c0392b] font-bold" data-id="element-24">$6.39</span> — menos
              que una consulta de 15 minutos
            </p>
            <button className="group relative inline-flex items-center justify-center px-8 py-4 bg-[#c0392b] text-white font-bold uppercase tracking-widest text-base sm:text-lg hover:bg-[#a93226] transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#c0392b] focus:ring-offset-[#0c1222] w-full sm:w-auto" data-id="element-25">
              <span data-id="element-26">DESCARGAR MI GUÍA Y BONOS AHORA</span>
              <ArrowRight className="ml-3 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-27" />
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}